var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProposal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 158,
    viewBox: "0 0 159 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.06152,
    y: 1.3916,
    width: 156,
    height: 155,
    rx: 73,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.3165 66.3534C94.9202 65.6958 94.2092 65.2943 93.4413 65.2943H85.8814L89.2149 51.9571C89.3791 51.303 89.2317 50.6096 88.8164 50.0782C88.4019 49.5467 87.7654 49.2358 87.0909 49.2358H70.1566C69.0953 49.2358 68.1873 49.9964 68.0012 51.041L62.5268 81.698C62.4129 82.3359 62.5874 82.9913 63.0034 83.4885C63.4194 83.9849 64.0341 84.2724 64.6822 84.2724H71.6376L70.3786 106.925C70.3216 107.953 70.9881 108.881 71.9801 109.156C72.1742 109.21 72.3714 109.236 72.5654 109.236C73.3617 109.236 74.1158 108.8 74.5019 108.069L95.3778 68.5059C95.7355 67.8278 95.7129 67.0111 95.3165 66.3534ZM75.307 97.1563L76.1383 82.2037C76.1719 81.6023 75.9566 81.0146 75.5427 80.5774C75.1296 80.1409 74.5543 79.8927 73.9522 79.8927H67.2975L71.9901 53.6153H84.2858L80.9522 66.9525C80.788 67.6065 80.9354 68.2999 81.3507 68.8313C81.7653 69.3628 82.4018 69.6737 83.0763 69.6737H89.8099L75.307 97.1563Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(49.0615 49.2358)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposal);
export default __webpack_public_path__ + "static/media/proposal.5ed69d41e1d63d0dc33358485c8b6a1f.svg";
export { ForwardRef as ReactComponent };